import { API_BASE_URL } from '../api/config';

/**
 * Resolves a backend-stored media URL to something an <img>/<video> tag can load from the
 * BROWSER. Backend media endpoints (ProductMediaController, ImagesController) store
 * gateway-relative paths like "/api/v1/product-media/…" with no origin — rendered as-is they
 * resolve against the calling frontend's own host (admin.kinmel.co.nz, or the storefront)
 * instead of the API gateway and 404. Mirrors ecommerce-app's getProductImageUrl, shared so
 * BOTH frontends use one rule.
 */
export function resolveMediaUrl(url: string | null | undefined): string {
  if (!url || !url.trim()) return '';
  const path = url.trim();
  if (
    path.startsWith('http://') ||
    path.startsWith('https://') ||
    path.startsWith('blob:') ||
    path.startsWith('data:')
  ) {
    return path;
  }
  if (path.startsWith('/api/')) return `${API_BASE_URL}${path}`;
  if (path.startsWith('/')) return path;
  return `${API_BASE_URL}/${path}`;
}
